import { STAGE_FEED_API_URL, FEED_API_URL, PRODUCTION_HOST } from '../config'
import { HelpUrl } from '../graphql'

export const T3_HELP_URL_KEY = 'T3_HELP_URL'
export const T3_AEMP_TRACKER_ASSET_ASSIGNMENT_KEY = 'T3_AEMP_TRACKER_ASSET_ASSIGNMENT'

export const getFeedApiURL = () => {
	const isProduction = location.host === PRODUCTION_HOST
	return isProduction ? FEED_API_URL : STAGE_FEED_API_URL
}

export const getHelpUrl = ( key: string, helpUrls: HelpUrl[] | undefined ): string => {
	return helpUrls?.find( ( url ) => url.key === key )?.value ?? ''
}
